/**
 * @generated SignedSource<<932104d5c6c0760de71c3f259ae376e7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RequestTypeCell$data = {
  readonly id?: string;
  readonly requestType: {
    readonly avatar: {
      readonly xsmall: string | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "RequestTypeCell";
};
export type RequestTypeCell$key = {
  readonly " $data"?: RequestTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestTypeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "RequestTypeCell",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "xsmall"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
};

(node as any).hash = "1ffac8b321378edaa179e16ac6a95065";

export default node;
